module.exports = __webpack_public_path__ + "fonts/b399395.ttf";